import React from "react";
import { useUscSelector } from "../../../../redux/store";
import { useUscLabel } from "../../../../utils/labels";
import { getEnabledServices, UscService } from "../../../../utils/helpers";
import WarrantyService from "./WarrantyService";
import CarDeliveryService from "./CarDeliveryService";
import Text from "../../../../../shared-components/toyota/styles/atoms/Text";
import * as PdpServicesStyles from "../../pdp/services/PdpServices.styles";
import ServicesWithDetailsList from "../../common/ServicesWithDetailsList";

const ServicesContainer = (): JSX.Element | null => {
    const vehicle = useUscSelector((state) => state.vehicle);
    const uscSettings = useUscSelector((state) => state.uscSettings);
    const dealer = useUscSelector((state) => state.dealer.dealer);
    const titleLabel = useUscLabel("uscServicesExtrasTitle");

    // eslint-disable-next-line array-callback-return
    const serviceComponents = getEnabledServices(vehicle, uscSettings, dealer).map((service) => {
        switch (service) {
            case UscService.Warranty:
                return <WarrantyService key="warranty" />;
            case UscService.CarDelivery:
                return <CarDeliveryService key="carDelivery" />;
        }
    });

    return (
        <>
            <PdpServicesStyles.Wrapper>
                <Text tag="h2" variant="h4">
                    {titleLabel}
                </Text>
                {serviceComponents}
            </PdpServicesStyles.Wrapper>
            <ServicesWithDetailsList />
        </>
    );
};

export default ServicesContainer;
